<template>
  <svg>
    <!-- 下边框 -->
    <g v-for="offset of borderArray" :transform="offset" :key="offset">
      <g v-for="item of polygonsArray" :key="item.adcode">
        <polygon
          stroke="#006ad3"
          stroke-width="2"
          fill="none"
          v-for="polygon of item.polygons"
          :points="polygon"
          :key="polygon"
        ></polygon>
      </g>
    </g>
    <filter
      id="border_filter"
      x="-2000%"
      y="-2000%"
      width="5000%"
      height="5000%"
    >
      <feOffset result="offOut" in="SourceGraphic" dx="0" dy="0" />
      <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
    </filter>
    <!-- 下面的阴影 -->
    <g transform="translate(0, 20)">
      <g v-for="offset of borderArray" :transform="offset" :key="offset">
        <g v-for="item of polygonsArray" :key="item.adcode">
          <polygon
            filter="url(#border_filter)"
            stroke="#006ad3"
            stroke-width="3"
            fill="none"
            v-for="polygon of item.polygons"
            :points="polygon"
            :key="polygon"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "BackgroundBorder",
  props: ["polygonsArray"],
  data: function() {
    return {
      borderArray: [
        // 底层轮廓线偏移
        "translate(0, 4)",
        "translate(0, 8)",
        "translate(0, 12)"
      ]
    };
  },
  beforeUpdate: function() {},
  mounted: function() {}
};
</script>
<style scoped>
svg {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
